<h2
  *ngIf="
    data !== 'New version available! Please reload to update.';
    else updateTemplate
  "
>
  {{ data | titlecase }}
</h2>

<ng-template #updateTemplate>
  <div class="update">
    <h2>{{ data | titlecase }}</h2>
    <button class="reload-button" mat-raised-button (click)="closeSnackBar()">
      Reload
    </button>
  </div>
</ng-template>
